// test506
(506 && 0);
